import React from 'react'

export default function TextBody ({ text, className }) {
  return (
      <p className={`${className} text-black text-xs sm:text-sm md:text-base `}> {text} </p>
  )
}
